import React, { useEffect, useState } from "react"
import { Modal, Form, Input, Row, Col, Spin, message, Tag, Upload } from "antd"
import SupplierManager from "src/services/SupplierManager"
import ContractCustomerService from "src/services/CustomerContractService"
import UserManagement from "src/services/UserManagement"
import TransactionManagement from "src/services/TransactionService"
import moment from "moment"
import { SectionCard, SectionTitle } from "./styled"
import { UploadOutlined } from "@ant-design/icons" // hoặc đúng path bạn có

// ...imports giữ nguyên

const ModalDetail = ({ visible, onClose, record }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [contractData, setContractData] = useState({})
  const [userDetail, setUserDetail] = useState({})

  useEffect(() => {
    const fetchDetail = async () => {
      if (!visible || !record?.ID) return

      setLoading(true)
      try {
        const res = await TransactionManagement.detailTransaction(record.ID)
        if (res?.success && typeof res.success === "object") {
          const data = res.success
          setContractData(data)
          form.setFieldsValue({
            id: data.ID,
            code: data.code,
            amount: data.amount,
            amount_in: data.amount_in,
            amount_out: data.amount_out,
            approved: data.approved?.fullname,
            balance: data.balance,
            customer_balance: data.customer?.balance,
            customer: data.customer?.fullname,
            created_at: data.created_at ? moment(data.created_at).format("DD-MM-YYYY") : "",
            approved_at: data.approved_at ? moment(data.approved_at).format("DD-MM-YYYY") : "",            
            status: data.status,
            note: data.note,
          })
        } else {
          message.error("Không tìm thấy thông tin hợp đồng!")
        }
      } catch (err) {
        console.error("Lỗi khi lấy thông tin:", err)
        message.error("Đã xảy ra lỗi khi lấy dữ liệu")
      } finally {
        setLoading(false)
      }
    }

    fetchDetail()
  }, [visible, record])
  return (
    <Modal
      title="Chi tiết giao dịch"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <SectionCard>
            <SectionTitle>Thông tin chung</SectionTitle>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Mã giao dịch" name="code">
                  <span>{form.getFieldValue("code")}</span>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Tên khách hàng" name="customer">
                  <span>{form.getFieldValue("customer")}</span>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="status" noStyle>
                  <span hidden>{form.getFieldValue("status")}</span>
                </Form.Item>
                <Form.Item label="Trạng thái">
                  {(() => {
                    const status = String(form.getFieldValue("status"))
                    switch (status) {
                      case "0":
                        return <Tag color="orange">Chờ duyệt</Tag>
                      case "1":
                        return <Tag color="green">Đã duyệt</Tag>
                      case "2":
                        return <Tag color="red">Từ chối</Tag>
                      case "3":
                        return <Tag color="blue">Đã ký</Tag>
                      default:
                        return <Tag color="default">Không xác định</Tag>
                    }
                  })()}
                </Form.Item>
              </Col>
              {form.getFieldValue("status") === 2 && (
                <Col span={12}>
                  <Form.Item label="Lý do từ chối" name="note">
                    <span>{form.getFieldValue("note")}</span>
                  </Form.Item>
                </Col>
              )}
            </Row>
          </SectionCard>
          <SectionCard>
            <SectionTitle>Số tiền</SectionTitle>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Số tiền giao dịch" name="amount">
                  <span>
                    {Number(form.getFieldValue("amount") || 0).toLocaleString()}
                  </span>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="amount_in" label="Số tiền vào">
                  <span>
                    {Number(
                      form.getFieldValue("amount_in") || 0,
                    ).toLocaleString()}
                  </span>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="amount_out" label="Số tiền ra">
                  <span>
                    {Number(
                      form.getFieldValue("amount_out") || 0,
                    ).toLocaleString()}
                  </span>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Số dư tài khoản của khách hàng"
                  name="customer_balance"
                >
                  <span>
                    {Number(
                      form.getFieldValue("customer_balance") || 0,
                    ).toLocaleString("vi-VN")}
                  </span>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Số dư tài khoản" name="balance">
                  <span>
                    {Number(form.getFieldValue("balance") || 0).toLocaleString(
                      "vi-VN",
                    )}
                  </span>
                </Form.Item>
              </Col>
            </Row>
          </SectionCard>

          <SectionCard>
          <SectionTitle>Thời gian</SectionTitle>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Ngày yêu cầu" name="created_at">
                <span>{form.getFieldValue("created_at") || ""}</span>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Ngày duyệt" name="approved_at">
                <span>{form.getFieldValue("approved_at") || ""}</span>
              </Form.Item>
            </Col>
          </Row>
        </SectionCard>
        </Form>
      </Spin>
    </Modal>
  )
}

export default ModalDetail
